import AdminAPI from "../../../api/admin"
import MetricAPI from "../../../api/metric"
import ProntoAiAPI from "../../../api/prontoAi"
import { useResponseHandle } from "../../hooks"

const metricAPI = new MetricAPI()
const adminAPI = new AdminAPI()
const prontoAiAPI = new ProntoAiAPI()

export const fetchGroupsHandler = async (params: any) => {
  const { token, dispatch, navigate, loading } = params

  loading(true)
  const response = await metricAPI.getMetricGroupsBoarded(token)

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempGroupArr: any = []

      result?.data?.forEach((group: any) => {
        tempGroupArr.push({ ...group, label: group?.group_name })
      })

      dispatch([...tempGroupArr])
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchRegionsHandler = async (params: any) => {
  const { token, dispatch, navigate, group } = params
  const { loading } = params

  loading(true)
  const response = await metricAPI.getMetricRegionsByGroups(token, [
    group?.group_sk,
  ])

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempRegionArr: any = [{ label: "All", name: "all" }]

      result?.data?.regions?.forEach((region: any) => {
        tempRegionArr.push({ ...region, label: region, name: region })
      })

      dispatch([...tempRegionArr])
    }
    loading(false)
  } else {
    loading(false)
    navigate("/auth")
  }
}
export const fetchOfficesHandler = async (params: any) => {
  const { token, dispatch, navigate } = params
  const { group, region } = params
  const { loading } = params

  loading(true)
  const response = await metricAPI.getMetricPracticesByRegions(
    token,
    [group?.group_sk],
    [region.name],
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      let tempOfficeArr: any = [
        { practice_sk: "all", label: "All", name: "all" },
      ]

      result?.data?.forEach((office: any) => {
        tempOfficeArr.push({
          ...office,
          practice_sk: office?.practice_sk,
          label: office?.name,
          name: office?.name,
        })
      })

      dispatch([...tempOfficeArr])
      loading(false)
    }
  } else {
    loading(false)
    navigate("/auth")
  }
}

export const fetchAdvisorList = async (props: any) => {
  const { token, dispatch } = props
  const { group } = props
  const { loading } = props

  loading(true)

  const response = await adminAPI.getAllAdvisors(token, group?.group_sk)

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      const advisor: Array<Object> = [{ label: "All", uid: "all" }]
      result?.data?.forEach((g: any) => {
        advisor.push({
          ...g,
          label: `${g.name}`,
        })
      })

      dispatch(advisor)
    }
  }

  loading(false)
}

export const fetchProntoAiTableDataHandler = async (params: any) => {
  const { token, dispatch } = params
  const { group, region, practice } = params
  const { loading } = params

  loading(true)
  const response = await prontoAiAPI.getProntoAiTableData(
    token,
    group?.group_sk,
    region?.name,
    practice?.practice_sk,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      console.log("result", result?.data)

      const columnHeaders = result?.data?.column_headers
      const tableData = result?.data?.data
      dispatch(columnHeaders, tableData)
    }
  }
  loading(false)
}

export const fetchProntoAiDataHandler = async (params: any) => {
  const { token, dispatch } = params
  const { metric } = params
  const response = await prontoAiAPI.getProntoAiData(
    token,
    metric?.group_sk,
    metric?.region,
    metric?.practice_sk,
    metric?.metric_id,
  )

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
    }
  }
}

export const fetchStoreById = async (props: any) => {
  const { metric, token, dispatch } = props

  const response = await metricAPI.getStoreById(token, metric?.metric_store_id)

  const result = useResponseHandle({
    apiResponse: response,
    successMessage: false,
  })

  if (result?.isAuthorized) {
    if (result?.statusCode == 200) {
      dispatch(result?.data)
      return result?.data
    }
  }
}
